<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
      <p class="mt-4 text-gray-600">Completing authentication...</p>
    </div>
  </div>
</template>

<script>
import authService from '../services/authService.js'
import { normalizePostAuthLabPath } from '../utils/labRoutes.js'

export default {
  name: 'SSOCallback',
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('duo_code')
    const state = urlParams.get('state')

    if (!code || !state) {
      this.$router.push({ name: 'Login', query: { error: 'Invalid callback parameters' } })
      return
    }

    try {
      const result = await authService.handleSSOCallback(code, state)
      
      if (result.success) {
        // Store session token
        if (result.user.session_token) {
          localStorage.setItem('session_token', result.user.session_token)
        }

        try {
          sessionStorage.setItem('sdm_pending_storage_check', '1')
        } catch (_) { /* ignore */ }
        
        // Redirect: use lab path from backend when present, else query.redirect or /
        const labPath = normalizePostAuthLabPath(
          result.user.redirect_path || (result.user.lab_id ? `/${result.user.lab_id}` : null)
        )
        if (labPath) {
          const targetPath = labPath.replace(/\/$/, '') + '/'
          window.location.href = window.location.origin + targetPath
        } else {
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        }
      } else {
        this.$router.push({ name: 'Login', query: { error: result.message } })
      }
    } catch (error) {
      console.error('SSO callback error:', error)
      this.$router.push({ name: 'Login', query: { error: 'Authentication failed' } })
    }
  }
}
</script>
